"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ByteArray = (function () {
    function ByteArray(len) {
        this.totalLength = len;
        this.init();
    }
    Object.defineProperty(ByteArray.prototype, "length", {
        get: function () {
            return this.remainLen;
        },
        enumerable: true,
        configurable: true
    });
    ByteArray.prototype.reset = function () {
        this.reNew();
    };
    ByteArray.prototype.resetRead = function () {
        this.readIndex = 0;
    };
    ByteArray.prototype.write = function (u8) {
        if (u8.byteLength > this.a8.byteLength - this.writeIndex) {
            var preLen = this.remainLen;
            var remain = new Uint8Array(this.a8.buffer, this.readIndex, preLen);
            this.reNew();
            this.a8.set(remain);
            this.writeIndex = preLen;
        }
        this.a8.set(u8, this.writeIndex);
        this.writeIndex += u8.byteLength;
    };
    ByteArray.prototype.read = function (len) {
        len = Math.min(len, this.remainLen);
        var t = new Uint8Array(this.a8.buffer, this.readIndex, len);
        this.readIndex += len;
        return t;
    };
    ByteArray.prototype.init = function () {
        this.reNew();
    };
    ByteArray.prototype.reNew = function () {
        this.a8 = new Uint8Array(this.totalLength);
        this.readIndex = 0;
        this.writeIndex = 0;
    };
    Object.defineProperty(ByteArray.prototype, "remainLen", {
        get: function () {
            return this.writeIndex - this.readIndex;
        },
        enumerable: true,
        configurable: true
    });
    return ByteArray;
}());
exports.ByteArray = ByteArray;
//# sourceMappingURL=ByteArray.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/byte/ByteArray.js
// module id = fmkg
// module chunks = 0